import { useState, useEffect } from "react";

export default function WaitingList() {
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [search, setSearch] = useState("");

  useEffect(() => {
    const fetchData = async () => {
      const token = localStorage.getItem("token");
      try {
        setLoading(true);
        const res = await fetch("https://zaichat.net/api/waiting_list", {
          headers: { auth: `Bearer ${token}` },
        });
        if (!res.ok) throw new Error("Failed to fetch waiting list");
        const result = await res.json();
        console.log(result)
        if(!result){
          console.log("there is nothing")
        }
        setData(result.data);
      } catch (err) {
        setError(err.message);
      } finally {
        setLoading(false);
      }
    };
    fetchData();
  }, []);

  // Filter by search
  const filteredData = data.filter(
    (item) =>
      item.name?.toLowerCase().includes(search.toLowerCase()) ||
      item.number?.toLowerCase().includes(search.toLowerCase()) ||
      item.id.toString().includes(search)
  );

  return (
    <div className="bg-white rounded-2xl shadow-lg border border-orange-200 p-6 md:p-8 mt-8">
      <div className="flex items-center justify-between mb-6">
        <h2 className="text-xl font-bold text-gray-800 flex items-center gap-2">
          <svg
            className="w-6 h-6 text-orange-500"
            fill="none"
            stroke="currentColor"
            viewBox="0 0 24 24"
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth={2}
              d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z"
            />
          </svg>
          Waiting List
        </h2>
        <input
          type="text"
          placeholder="Search by name or number..."
          className="p-2 border rounded-lg w-full md:w-64 focus:outline-none focus:ring-2 focus:ring-orange-300"
          value={search}
          onChange={(e) => setSearch(e.target.value)}
        />
      </div>

      {loading ? (
        <div className="text-center py-16">
          <svg
            className="w-12 h-12 text-orange-500 mx-auto mb-4 animate-spin"
            fill="none"
            viewBox="0 0 24 24"
          >
            <circle
              className="opacity-25"
              cx="12"
              cy="12"
              r="10"
              stroke="currentColor"
              strokeWidth="4"
            ></circle>
            <path
              className="opacity-75"
              fill="currentColor"
              d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
            ></path>
          </svg>
          <p className="text-gray-500">Loading waiting list...</p>
        </div>
      ) : error ? (
        <div className="text-center py-16">
          <p className="text-red-600 font-medium">{error}</p>
        </div>
      ) : (
        <div className="overflow-x-auto">
          <table className="w-full border-collapse">
            <thead>
              <tr className="bg-orange-50 text-gray-700 font-semibold">
                <th className="border border-orange-200 p-3 text-left">ID</th>
                <th className="border border-orange-200 p-3 text-left">Name</th>
                <th className="border border-orange-200 p-3 text-left">Phone Number</th>
                <th className="border border-orange-200 p-3 text-left">Created At</th>
              </tr>
            </thead>
            <tbody>
              {filteredData.length === 0 ? (
                <tr>
                  <td colSpan="4" className="text-center py-12 text-gray-500">
                    <div className="flex flex-col items-center justify-center gap-3">
                      <svg
                        className="w-16 h-16 text-gray-300"
                        fill="none"
                        stroke="currentColor"
                        viewBox="0 0 24 24"
                      >
                        <path
                          strokeLinecap="round"
                          strokeLinejoin="round"
                          strokeWidth={2}
                          d="M9.172 16.172a4 4 0 015.656 0M9 10h.01M15 10h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z"
                        />
                      </svg>
                      <p className="font-medium">No entries found</p>
                      <p className="text-sm text-gray-400">
                        Try adjusting your search criteria
                      </p>
                    </div>
                  </td>
                </tr>
              ) : (
                filteredData.map((item) => (
                  <tr key={item.id} className="hover:bg-orange-50 transition-colors">
                    <td className="border border-orange-100 p-3 font-medium text-gray-700">
                      #{item.id}
                    </td>
                    <td className="border border-orange-100 p-3">
                      <div className="flex items-center gap-2">
                        <div className="w-8 h-8 rounded-full bg-orange-100 flex items-center justify-center text-orange-600 font-semibold text-sm">
                          {item.name ? item.name.charAt(0).toUpperCase() : "?"}
                        </div>
                        <span className="font-medium text-gray-800">
                          {item.name || (
                            <span className="text-gray-400 italic">Unknown</span>
                          )}
                        </span>
                      </div>
                    </td>
                    <td className="border border-orange-100 p-3 text-gray-600">
                      {item.number || <span className="text-gray-400 italic">—</span>}
                    </td>
                    <td className="border border-orange-100 p-3 text-gray-600">
                      {item.created_at}
                    </td>
                  </tr>
                ))
              )}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
}
